import React, { CSSProperties } from "react";
import Button from "../Button";
import CheckBox from "./CheckBox";

interface LabelCheckBoxProps {
    className?: string
    checked?: boolean
    disabled?: boolean
    buttonColor?: string
    borderColor?: string
    borderOnColor?: string
    borderRadius?: number
    labelText?: string
    buttonClassName?: string
    textClassName?: string
    fontFamily?: string
    fontSize?: number
    color?: string
    letterSpacing?: number
    onChange?: Function
    key?: number
    style?: CSSProperties
    textStyle?: CSSProperties
}
const LabelCheckBox = ({className, checked, disabled, buttonColor, borderColor, borderOnColor, borderRadius, labelText, buttonClassName, textClassName, fontFamily, fontSize, color, letterSpacing, onChange, key, style, textStyle}: LabelCheckBoxProps) => {
    const [hoverState, setHoverState] = React.useState<boolean>(false);

    return (
        <div
            key={key}
            className={"dpFlx aiC csP " + (className ? className : "")}
            style={style}
            onMouseOver={() => setHoverState(true)}
            onMouseOut={() => setHoverState(false)}
        >
            <CheckBox
                checked={checked}
                disabled={disabled}
                buttonClassName={buttonClassName}
                buttonColor={buttonColor}
                borderColor={hoverState ? borderOnColor : borderColor}
                borderOnColor={borderOnColor}
                borderRadius={borderRadius}
                onChange={() => {
                    if (!disabled) {
                        if (!onChange) {
                            return;
                        }
                        onChange(checked!)
                    }
                }}
            />
            <Button
                buttonName={labelText}
                textClass={textClassName}
                fontFamily={fontFamily}
                fontSize={fontSize}
                color={color}
                letterSpacing={letterSpacing}
                style={textStyle}
                disabled={disabled}
                onClickFunc={() => {
                    if (!onChange) {
                        return;
                    }
                    onChange(checked!)
                }}
            />
        </div>
    )
}
export default LabelCheckBox;